export default __webpack_public_path__ + "assets/13.334d390c.png";